<div class="loader-overlay" *ngIf="isShown$ | ngrxPush" @fade>
    <mat-spinner [diameter]="diameter$ | ngrxPush" color="accent"></mat-spinner>
</div>
